import React from "react";
import { Container, Header, Segment, List, Image } from "semantic-ui-react";

const PoliticaPrivacidadePage: React.FC = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8f9fa',
      padding: '0'
    }}>
      {/* Header com Logo */}
      <div style={{
        backgroundColor: 'white',
        borderBottom: '1px solid #e9ecef',
        padding: '1.5rem 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Container textAlign="center">
          <Image 
            src="/images/logo-gettel.png" 
            alt="Gettel Logo" 
            size="small"
            style={{ maxHeight: '60px' }}
          />
        </Container>
      </div>

      {/* Conteúdo Principal */}
      <Container text style={{ 
        padding: '3rem 2rem',
        maxWidth: '800px',
        lineHeight: '1.6'
      }}>
        <Header as="h1" textAlign="center" style={{ 
          marginBottom: '2rem',
          color: '#2c3e50',
          fontSize: '2.2rem'
        }}>
          Política de Privacidade
        </Header>
        
        <Header as="h2" textAlign="center" style={{ 
          marginBottom: '2rem',
          color: '#6c757d',
          fontSize: '1.2rem',
          fontWeight: 'normal'
        }}>
          Gettel Automação
        </Header>
        
        <p style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          fontSize: '1.1rem',
          color: '#495057'
        }}>
          <strong>Última atualização:</strong> 13 de outubro de 2025
        </p>

        <Segment vertical style={{ 
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '2rem',
          marginBottom: '2rem'
        }}>
          <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
            A <strong>Gettel Automação</strong>, sob a razão social <strong>E.R. 2 GESTAO EM TELECOMUNICACOES LTDA</strong>,
            valoriza a segurança, a privacidade e a transparência no tratamento das informações
            de seus clientes e usuários.
          </p>
          <p style={{ fontSize: '1.1rem' }}>
            Esta Política de Privacidade tem como objetivo informar de forma clara como coletamos,
            utilizamos e protegemos os dados pessoais tratados em nossos sistemas, plataformas e integrações.
          </p>
        </Segment>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          1. Coleta de informações
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
          A Gettel Automação <strong>não coleta nem armazena dados sensíveis</strong> (como informações
          financeiras, biométricas, de saúde ou documentos pessoais completos).
        </p>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>Os únicos dados coletados são:</p>
        <List bulleted style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          <List.Item>Dados de contato fornecidos voluntariamente pelo usuário (nome, telefone, e-mail ou CNPJ);</List.Item>
          <List.Item>Informações técnicas básicas de acesso (como IP e data/hora de uso), para fins de segurança e registro de atividade;</List.Item>
          <List.Item>Dados operacionais necessários para a execução de automações, integrações e notificações contratadas.</List.Item>
        </List>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          2. Uso das informações
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>As informações são utilizadas apenas para:</p>
        <List bulleted style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          <List.Item>Enviar comunicações transacionais e operacionais (como mensagens automatizadas via WhatsApp API);</List.Item>
          <List.Item>Cumprir obrigações contratuais e legais;</List.Item>
          <List.Item>Garantir a segurança e integridade dos sistemas;</List.Item>
          <List.Item>Melhorar a experiência dos usuários em nossos serviços.</List.Item>
        </List>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          A Gettel Automação <strong>não compartilha, vende ou repassa</strong> informações de seus usuários
          a terceiros, exceto quando necessário para o cumprimento da lei ou operação técnica essencial
          (como provedores de hospedagem e APIs da Meta).
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          3. Armazenamento e segurança dos dados
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
          Empregamos medidas técnicas e administrativas adequadas para proteger as informações sob nossa
          responsabilidade contra acessos não autorizados, destruição acidental ou ilegal, perda, alteração
          ou qualquer forma de tratamento inadequado.
        </p>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          Todos os dados trafegam de forma segura, com <strong>criptografia e controle de acesso restrito</strong>.
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          4. Compartilhamento de dados
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>Os dados poderão ser compartilhados apenas com serviços essenciais à execução das integrações, como:</p>
        <List bulleted style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          <List.Item>Meta Platforms, Inc. (WhatsApp Business API);</List.Item>
          <List.Item>Fornecedores de infraestrutura de nuvem e hospedagem.</List.Item>
        </List>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          Esse compartilhamento ocorre <strong>sempre em conformidade com a LGPD</strong> e demais legislações aplicáveis.
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          5. Retenção e exclusão
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          Os dados são mantidos somente pelo tempo necessário para cumprir as finalidades para as quais foram coletados.
          O usuário pode solicitar a exclusão ou portabilidade de suas informações a qualquer momento, conforme previsto na LGPD.
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          6. Direitos do titular
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
          De acordo com a Lei nº 13.709/2018 (LGPD), o titular dos dados pode, a qualquer momento:
        </p>
        <List bulleted style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          <List.Item>Solicitar acesso, correção ou exclusão de seus dados;</List.Item>
          <List.Item>Revogar consentimentos concedidos;</List.Item>
          <List.Item>Solicitar informações sobre o uso e o compartilhamento de seus dados.</List.Item>
        </List>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          As solicitações podem ser feitas pelo e-mail: <strong>privacidade@gettel.com.br</strong>
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          7. Alterações nesta política
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          A Gettel Automação pode atualizar esta Política de Privacidade periodicamente.
          Recomendamos revisitar esta página sempre que houver atualizações significativas.
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          8. Informações da empresa
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          <strong>Razão Social:</strong> E.R. 2 GESTAO EM TELECOMUNICACOES LTDA<br />
          <strong>Nome Fantasia:</strong> Gettel Automação<br />
          <strong>CNPJ:</strong> 61.286.322/0001-33<br />
          E-mail de contato: <strong>privacidade@gettel.com.br</strong><br />
          Website: <strong>https://gettel.com.br</strong>
        </p>

        <Header as="h2" style={{ 
          color: '#2c3e50',
          marginTop: '2.5rem',
          marginBottom: '1.5rem',
          fontSize: '1.8rem'
        }}>
          Conclusão
        </Header>
        <p style={{ fontSize: '1.1rem', marginBottom: '3rem' }}>
          A Gettel Automação atua com total transparência e responsabilidade, não armazena dados sensíveis,
          e utiliza as informações de forma limitada, segura e ética — sempre visando proteger a privacidade
          de seus clientes e parceiros.
        </p>
      </Container>
    </div>
  );
};

export default PoliticaPrivacidadePage;
